<template>
  <button class="common-button-component" :class="{loading : loading, disabled: value.disabled}" @click="clickButton">
    {{value.text}}
  </button>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickButton() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
.common-button-component{
  width: 100%;
  padding: 20px 0;
  color: white;
  font-weight: 500;
  font-size: 36px;
  line-height: 50px;
  text-align: center;
  background: $theme_color;
  border: 0;
  border-radius: 45px;
  outline: none;
}
.loading {
  background: #fdb580;
}
</style>
